import { AppConfig } from '@shared/definitions';

export const appConfig: AppConfig = {
  /* PAUL-3246 has not rolled this app over yet — `config` with the historical minute keeps
     today's behaviour until its backend is checked for JWT access tokens. */
  tokenExpiration: { source: 'config', minutes: 1 },
  app: 'pauly-client',
  appTitle: 'Pauly Client',
  email: '',
  gtm: '',
  logo: {
    light: '/logo/logo-light-pauly.svg',
    dark: '/logo/logo-dark-pauly.svg',
    mark: '/logo/logo-dark-pauly.svg',
  },
  language: { defaultLanguage: 'nl', languages: [{ code: 'nl', iconFlagPath: 'assets/flags/netherlands.png' }] },
  disabledAuthPopup: true,
  withinDialogScrolling: true,
};
